<template>
    <div class="terms-cond" :class="{'terms-cond--show' : show}">
        <button class="terms-cond__close icon" @click="accept"></button>

        <div class="terms-cond__content">
            <p class="terms-cond__text">
                <span v-html="content.cookieText"></span>
                <a class="terms-cond__link" :href="content.cookieLink" v-html="content.cookieLinkLabel"></a>
            </p>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapGetters([
        'content'
      ])
    },
    mounted: function() {
      if (this.isShowTerms()) {
        setTimeout(() => {
          this.show = true;
        }, 1000);
      }
    },
    methods: {
      accept: function() {
        localStorage.setItem('terms_accept', true);
        localStorage.setItem('terms_accept_exp', (Date.now() / 1000) + 48 * 60 * 60);
        this.show = false;
      },
      isShowTerms() {
        let show = false;
        if (localStorage.getItem('terms_accept')) {
          let expiration = localStorage.getItem('terms_accept_exp');
          if (!expiration || (Date.now() / 1000) > parseInt(expiration)) {
            show = true;
          }
        } else {
          show = true;
        }

        return show;
      }
    }
  }
</script>